import { Delete, EditCalendarOutlined } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { Link } from "react-router-dom";
import { maskedAccountId } from "../../common/Utils";
import "../Styles/AdminListings.css";
import {caseInsensitiveSort} from "../../common/Utils";

export const careFacilityColumns = (handleDelete, userAccessRole) => [
	{
		name: 'Care Facility',
		selector: row => row.companyName ? row.companyName.toUpperCase(): "",
        sortable: true,
		wrap: true,
		minWidth:"160px",
		center:true,
		style: {
			justifyContent: "center",
			textAlign:"center"
		},
		sortFunction: (rowA, rowB) => caseInsensitiveSort(rowA, rowB, (row) => row.companyName? row.companyName:""),
	},
	{
		name: 'Parent Company',
		selector: (row) => <div style={{textAlign:"center", align:"center"}}>
			{row.parentCompanyName? row.parentCompanyName.toUpperCase(): ""}</div>,
        sortable: true,
		minWidth:"160px",
		center:true,
		style: {
			justifyContent: "center",
			textAlign:"center"
		},
		sortFunction: (rowA, rowB) => caseInsensitiveSort(rowA, rowB, (row) => row.parentCompanyName? row.parentCompanyName:""),
	},
	{
		name: 'Account No.',
		selector: row => <div>{row.isChild == "YES" || row.isStandAlone == "YES" ? maskedAccountId(row.accountNumber) : ""}</div>,
        sortable: true,
		minWidth:"150px",
		center:true,
		wrap: true,
		style: {
			justifyContent: "center",
			textAlign:"center"
		},
	},
	{
		name: 'Address',
		selector: row => row.address,
        sortable: true,
		wrap: true,
		minWidth:"150px",
		center:true,
		style: {
			justifyContent: "center",
			textAlign:"center"
		},
		sortFunction: (rowA, rowB) => caseInsensitiveSort(rowA, rowB, (row) => row.address? row.address:""),
	},
	{
		name: 'Contact Name',
		selector: row => row.contactPerson,
        sortable: true,
		wrap: true,
		minWidth:"160px",
		center:true,
		style: {
			justifyContent: "center",
			textAlign:"center"
		},
		sortFunction: (rowA, rowB) => caseInsensitiveSort(rowA, rowB, (row) => row.contactPerson ? row.contactPerson :""),
	},
	{
		name: 'Reliable',
		selector: row => row.isReliable,
        sortable: true,
		wrap: true,
		minWidth:"160px",
		center:true,
		style: {
			justifyContent: "center",
			textAlign:"center"
		},
		sortFunction: (rowA, rowB) => caseInsensitiveSort(rowA, rowB, (row) => row.isReliable ? row.isReliable :""),
	},
	{
		name: 'Created Date',
		selector: row => row.createdDate,
        sortable: true,
		wrap: true,
		minWidth:"160px",
		center:true,
		style: {
			justifyContent: "center",
			textAlign:"center"
		},
		sortFunction: (rowA, rowB) => caseInsensitiveSort(rowA, rowB, (row) => row.createdDate ? row.createdDate :""),
	},
	{
		name: 'Created By',
		selector: row => row.createdBy,
        sortable: true,
		wrap: true,
		minWidth:"160px",
		center:true,
		style: {
			justifyContent: "center",
			textAlign:"center"
		},
		sortFunction: (rowA, rowB) => caseInsensitiveSort(rowA, rowB, (row) => row.createdBy ? row.createdBy :""),
	},
	{
		name: 'No. of Users',
		wrap: true,
		minWidth:"150px",
		center:true,
		style: {
			justifyContent: "center",
			textAlign:"center"
		},
		cell : row =>  (
			<div className="center-aligned-cell">
				{row.isChild == "YES" || row.isStandAlone == "YES" ?
				 ((row.numberOfUsers > 0) ? <Link to="/admin/careUserListings/view" state={row} style={{justifyContent:'center'}}>{row.numberOfUsers}</Link>
				: <p>{row.numberOfUsers}</p>) 
				: ""
				}
			</div>),
	},
	{
		name: 'Action',
		minWidth:"120px",
		center:true,
		style: {
			justifyContent: "center",
			textAlign:"center"
		},
		omit: userAccessRole === "" || userAccessRole === "Read" || userAccessRole === undefined || userAccessRole === null,
		cell: row => <div style={{display:'flex', flexDirection:'row', textAlign:'center'}}>
			<Link to="/admin/newCareFacility/edit" state={row}>
				<IconButton sx={{ boxShadow:'none'}} title="Edit">
					<EditCalendarOutlined sx={{ color:'#002d82'}} />
				</IconButton>
			</Link>
			
			<IconButton sx={{ boxShadow:'none'}}  onClick={() => handleDelete(row)} title="Delete">
				<Delete sx={{ color:'#cd5c5c'}} />
			</IconButton>
		</div>
	}
];

export const exportCareFacilityColumns =[
	{
		header: 'Care Facility',
		key: 'companyName',
	},
	{
		header: 'Parent Company',
		key: 'parentCompanyName',
	},
	{
		header: 'Account No.',
		key: 'accountNumber',
	},
	{
		header: 'Address',
		key: 'address',
	},
	{
		header: 'Contact Name',
		key: 'contactPerson',
	},
	{
		header: 'Reliable',
		key: 'isReliable',
	},
	{
		header: 'Created Date',
		key: 'createdDate',
    },
	{
	 	header: 'Created By',
	 	key: 'createdBy',
	},
	{
		header: 'No. of Users',
		key : 'numberOfUsers'
	},
	
]